import React from "react";
import { portfolioData } from "../data/portfolioData";

const About = () => {
  const { about, sections } = portfolioData;

  return (
    <section id="about" className="py-16 scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-3xl font-bold text-white">{sections.aboutTitle}</h2>
        <div className="mt-6 rounded-3xl border border-slate-700/60 bg-slate-900/50 p-8">
          <p className="text-base leading-relaxed text-slate-300">{about}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
